/** Router paths relative to the admin SPA basename (`/admin`). */

export const ADMIN_RADAR_LEGISLATION_CORPUS_PATH = '/radar/legislation-corpus'
export const ADMIN_RADAR_REVIEW_PATH = '/radar/review'
export const ADMIN_DIAGNOSTICS_INGESTIONS_PATH = '/diagnostics/ingestions'
export const ADMIN_ORGANIZATIONS_PATH = '/organizations'
export const ADMIN_EVAL_TASKS_PATH = '/evals/tasks'
export const ADMIN_EVAL_HELP_PATH = '/evals/help'
export const ADMIN_EVAL_EXTRACTION_PATH = '/evals/extraction'
export const ADMIN_EVAL_LEGISLATION_APPLICABILITY_SUITE_SLUG =
  'legislation-applicability'
export const ADMIN_EVAL_STANDARDS_EXTRACTION_SUITE_SLUG =
  'standards-extraction'

export function adminDiagnosticsIngestionDetailPath(sourceId: string): string {
  return `${ADMIN_DIAGNOSTICS_INGESTIONS_PATH}/${sourceId}`
}

export function adminOrganizationDetailPath(organizationId: string): string {
  return `${ADMIN_ORGANIZATIONS_PATH}/${organizationId}`
}

export function adminEvalTaskNewPath(): string {
  return `${ADMIN_EVAL_TASKS_PATH}/new`
}

export function adminEvalHelpPath(sectionId?: string): string {
  if (!sectionId) {
    return ADMIN_EVAL_HELP_PATH
  }
  return `${ADMIN_EVAL_HELP_PATH}#${sectionId}`
}

export function adminEvalLegislationTaskNewPath(): string {
  return `${ADMIN_EVAL_TASKS_PATH}/${ADMIN_EVAL_LEGISLATION_APPLICABILITY_SUITE_SLUG}/new`
}

export function adminEvalPedLegislationTaskNewPath(): string {
  return `${adminEvalLegislationTaskNewPath()}?law=ped`
}

export function adminEvalTaskPath(taskVersionId: string): string {
  return `${ADMIN_EVAL_TASKS_PATH}/${ADMIN_EVAL_LEGISLATION_APPLICABILITY_SUITE_SLUG}/${taskVersionId}`
}

export function adminEvalExtractionNewPath(): string {
  return `${ADMIN_EVAL_TASKS_PATH}/${ADMIN_EVAL_STANDARDS_EXTRACTION_SUITE_SLUG}/new`
}

export function adminEvalExtractionPath(taskVersionId: string): string {
  return `${ADMIN_EVAL_TASKS_PATH}/${ADMIN_EVAL_STANDARDS_EXTRACTION_SUITE_SLUG}/${taskVersionId}`
}

export function adminEvalExtractionAbsolutePath(taskVersionId: string): string {
  return `/admin${adminEvalExtractionPath(taskVersionId)}`
}

export const ADMIN_EVAL_EXPERIMENTS_PATH = '/evals/experiments'

export function adminEvalExperimentPath(experimentId: string): string {
  return `${ADMIN_EVAL_EXPERIMENTS_PATH}/${experimentId}`
}

export const ADMIN_EVAL_TRIALS_PATH = '/evals/trials'
export const ADMIN_EVAL_COMPARE_PATH = '/evals/compare'

export function adminEvalTrialPath(trialId: string): string {
  return `${ADMIN_EVAL_TRIALS_PATH}/${trialId}`
}

export function adminEvalComparePath(
  baselineId: string,
  candidateId: string
): string {
  return `${ADMIN_EVAL_COMPARE_PATH}/${baselineId}/${candidateId}`
}

export function isAdminNavPathActive(
  pathname: string,
  path: string,
  aliases: string[] = []
): boolean {
  return [path, ...aliases].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}
